import { ErrorHandler, Injectable } from '@angular/core';

export interface RecentError {
  t: string;
  message: string;
  stack: string;
}

/**
 * Angular's default ErrorHandler only prints to the console, which on a kiosk nobody
 * ever sees. This one also keeps the last few errors in memory so the click
 * diagnostic can attach them to a freeze report. In particular, a failed DOM removal
 * during a route transition (the leftover-page freeze) would surface here.
 */
@Injectable()
export class AppErrorHandler extends ErrorHandler {

  private static readonly KEEP = 10;
  private static recent: RecentError[] = [];

  static getRecent(): RecentError[] {
    return AppErrorHandler.recent.slice();
  }

  handleError(error: any): void {
    try {
      const err = error && error.rejection ? error.rejection : error;
      const message = err && err.message ? String(err.message) : String(err);
      const stack = err && err.stack ? String(err.stack).split('\n').slice(0, 4).join(' | ') : '';
      AppErrorHandler.recent.push({ t: new Date().toISOString(), message: message.slice(0, 500), stack: stack.slice(0, 600) });
      if (AppErrorHandler.recent.length > AppErrorHandler.KEEP) {
        AppErrorHandler.recent.shift();
      }
    }
    catch (e) { }
    super.handleError(error);
  }
}
